import OperationDetails from 'modules/transactions/pages/OperationDetails';
import { OperationDetailsPageProvider } from 'modules/transactions/pages/OperationDetails/context/OperationDetailsPageContext';

const OperationDetailsPage = () => (
  <OperationDetailsPageProvider>
    <OperationDetails />
  </OperationDetailsPageProvider>
);

export default OperationDetailsPage;
